import {PayloadAction} from "@reduxjs/toolkit";
import {Dispatch} from "react";
import {ScheduledShipmentService} from "../service/Order/ScheduledShipmentService";

export class ScheduledShipmentController {
    private dispatch: Dispatch<PayloadAction<any>>
    private service: ScheduledShipmentService

    constructor(dispatch: Dispatch<PayloadAction<any>>) {
        this.dispatch = dispatch
        this.service = new ScheduledShipmentService(this.dispatch)
    }


    public async all(data?: any) {
        return this.service.all(data).then(res => {
            return res
        })
    }

    public async remove(params: any) {
        return this.service.remove(params).then(res => {
            return res
        })
    }

    public async create(data: any) {
        return this.service.create(data).then(res => {
            return res
        })
    }
    public async edit(data: any) {
        return this.service.edit(data).then(res => {
            return res
        })
    }

    public async force(data: any) {
        return this.service.force(data).then(res => {
            return res
        })
    }

    public clearListShipment() {
        return this.service.clearListShipment()
    }
}
